module.exports = __webpack_public_path__ + "img/half-circle.1d876e29.svg";